<template>
    <section class="app-main">
        <div class="top-bar">
            <el-date-picker 
                v-model="date" 
                @change="handleDate"
                type="daterange" 
                range-separator="至"
                start-placeholder="开始日期" 
                end-placeholder="结束日期" 
                value-format="yyyy-MM-dd" 
                style="width:260px;margin-right:20px"
            >
            </el-date-picker>
            <el-input placeholder="搜索商品" v-model="search"  style="width:300px;" @change="getData">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>

        <!-- 商品列表 -->
        <div class="content">
            <el-table :data="tableData"  height="630" style="width: 100%">
                <el-table-column prop="goods_image" label="商品图片" align="center">
                    <template slot-scope="scope">
                        <m-img :src="scope.row.goods_image" />
                    </template>
                </el-table-column>
                <el-table-column prop="goods_name" label="商品名称" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="goods_status" label="商品状态" align="center">
                    <template slot-scope="scope">
                        <el-link type="success" v-if="scope.row.goods_status == 1">已上架</el-link>
                        <el-link type="danger"  v-if="scope.row.goods_status == 2">已下架</el-link>
                        <el-link type="info"    v-if="scope.row.goods_status == 3">待审核</el-link>
                        <el-link type="success" v-if="scope.row.goods_status == 4">待上架</el-link>
                        <el-link type="danger"  v-if="scope.row.goods_status == 5">已回收</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="goods_number" label="销售数量" align="center"></el-table-column>
                <el-table-column prop="email" label="当前库存" align="center">
                    <template slot-scope="scope">
                        <el-popover  placement="top-end" width="400" trigger="click">
                            <el-table :data="scope.row.sku_list" max-height="300">
                                <el-table-column prop="sku_name" label="sku名称"  align="center" show-overflow-tooltip>
                                </el-table-column>
                                <el-table-column prop="stock" label="库存"   align="center">
                                </el-table-column>
                            </el-table>
                            <el-button slot="reference" type="primary" plain size="mini">查看详情</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next, jumper" :page-size="size" style="padding:10px" :total="total"  @current-change="loadPage"></el-pagination>
        </div>


    </section>
</template>



<script>
import { goodsList } from '@/api/summary.js'
import MImg from "@/components/Image";

export default {
    components: {
        MImg
    },
    data() {
        return {
            search:'',
            page:1,
            size:20,
            total:0,
            tableData:[],
            date: ''
        }
    },
    methods: {
        handleDate() {
            this.getData()
        },
        getData(){
            let params = {
                page:this.page
            }
            if(this.search != ""){
                params.search = this.search
            }
            if(this.date != '' && this.date != null) {
                params.start_date_search = this.date[0]
                params.end_date_search = this.date[1]
            }
            this.table_load = true;
            goodsList(params).then(res => {
                if(res) {
                    this.tableData = res.data
                    this.size = res.page_size
                    this.total = res.total_data
                }
            })
        },
        loadPage(page){
            this.page = page;
            this.getData()
        },
        goDetail(row) {
            console.log(row)
        }
    },
    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
.section{
  .top-bar { padding:0 30px 20px;width:100%; 
        >p { height: 50px;line-height: 50px;text-align: center; }
    }
    .content {
        margin : 10px 30px;
        border:1px solid #e0e0e0;
    }
    .shop-title {
        text-align: left;
        height: 40px;
        line-height: 40px;
    }
    .shop-info {
        border: 1px solid #e0e0e0;
        text-align: left;
        padding-left: 10px;
        height: 40px;
        line-height: 40px;
        border-radius: 3px;
    }
    .imgs-box {
        height: 120px;
        text-align: left;
        >img {
            height: 120px;
            margin-right: 50px;
        }
    }
}
</style>


